import axios from 'axios';
import jwtDecode from 'jwt-decode';

import { refreshToken } from '../redux-store/auth/authAPI';
import { tokenValidator } from './tokenValidator';

// Add a request interceptor
const axiosInstance = axios.create();
axiosInstance.defaults.adapter = require('axios/lib/adapters/http');

axiosInstance.interceptors.request.use(
  async (config: any) => {
    const tokens = await tokenValidator();
    config.withCredentials = true;
    // Attaching token to headers for authentication on backend
    if (tokens) {
      const tokenDecoded: any = jwtDecode(tokens.AccessToken);
      const expiry = tokenDecoded.exp;
      const now = new Date();
      // Check Expiry - getting current time and adding 5000 millisecond buffer
      if (now.getTime() + 5000 < expiry * 1000) {
        config.headers.Authorization = tokens.AccessToken;
        config.headers.Authentication = tokens.IdToken;
        config.headers['X-Content-Type-Options'] = 'nosniff';
      } else {
        const baseURL = window.__env.baseURL;
        const tokensRefreshed: any = await refreshToken(baseURL);

        config.headers.Authorization = tokensRefreshed.AccessToken;
        config.headers.Authentication = tokensRefreshed.IdToken;
        config.headers['X-Content-Type-Options'] = 'nosniff';
        return config;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default axiosInstance;
